(function() {

  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  });

  function formatMoney(amount) {
    return formatter.format(amount);
  }

  async function fetchBundlePrice(productUrl, priceElId) {
    const priceEl = document.getElementById(priceElId);
    if (!priceEl) return;

    try {
      const res = await fetch(productUrl);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const bundleWrapper = doc.querySelector('#simple-bundles-io-options');
      
      if (!bundleWrapper) {
        priceEl.innerHTML = 'View Options';
        return;
      }

      const allSelects = Array.from(bundleWrapper.querySelectorAll('select'));

      const itemSelect = bundleWrapper.querySelector('select#item');
      const visibleSelects = allSelects.filter(select => {
        const label = doc.querySelector(`label[for="${select.id}"]`);
        const isHidden =
          select.style.display === 'none' ||
          select.id === 'item' ||
          (label && label.style.display === 'none');
        return !isHidden;
      });

      let minPrice = 0;

      if (itemSelect) {
        const baseOption = itemSelect.querySelector('option[data-price]');
        const basePrice = baseOption ? parseFloat(baseOption.getAttribute('data-price')) || 0 : 0;

        if (basePrice > 0) {
          let minExtra = 0;

          visibleSelects.forEach(select => {
            const options = Array.from(select.querySelectorAll('option[data-price-diff]'));
            if (options.length === 0) return;

            const firstDiff = parseFloat(options[0].getAttribute('data-price-diff')) || 0;
            minExtra += firstDiff;
          });

          minPrice = basePrice + minExtra;
        }
      }

      if (minPrice === 0) {
        let minSum = 0;

        visibleSelects.forEach(select => {
          const options = Array.from(select.querySelectorAll('option[data-price]'));
          if (options.length === 0) return;

          const firstRealOption = options.find(opt => {
            return (parseFloat(opt.getAttribute('data-price')) || 0) > 0;
          });

          const firstPrice = firstRealOption
            ? parseFloat(firstRealOption.getAttribute('data-price')) || 0
            : 0;
          minSum += firstPrice;
        });

        minPrice = minSum;
      }

      if (minPrice === 0) {
        priceEl.innerHTML = 'View Options';
      } else {
        console.log(minPrice, "minPrice")
        priceEl.innerHTML = 'From ' + formatMoney(minPrice);
      }

    } catch(e) {
      console.error('Bundle price fetch error:', e);
      const priceEl = document.getElementById(priceElId);
      if (priceEl) priceEl.innerHTML = 'View Options';
    }
  }

  function initBundlePrices() {
    document.querySelectorAll('.product__box_collection[data-is-bundle="true"]').forEach(card => {
      const url = card.getAttribute('data-product-url');
      const elId = card.getAttribute('data-bundle-price-el');
      if (url && elId) {
        fetchBundlePrice(url, elId);
      }
    });
  }

  // ─── Shopify AJAX filter listener ───────────────────────────────────────────

  // 1. Patch pushState to detect URL changes from filter clicks
  const _pushState = history.pushState.bind(history);
  history.pushState = function(state, title, url) {
    _pushState(state, title, url);
    window.dispatchEvent(new Event('shopify:filter:applied'));
  };

  // 2. Also catch browser back/forward through filtered URLs
  window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('shopify:filter:applied'));
  });

  // 3. On filter applied, wait for DOM re-render then re-init
  window.addEventListener('shopify:filter:applied', () => {
    // MutationObserver watches for the product grid to be re-rendered
    const productGrid = document.querySelector('.collection-grid, .product-grid, [data-product-grid], #product-grid, .product__list__grid');

    if (productGrid) {
      const observer = new MutationObserver((mutations, obs) => {
        const hasNewCards = document.querySelectorAll('.product__box_collection[data-is-bundle="true"]').length > 0;
        if (hasNewCards) {
          obs.disconnect();
          initBundlePrices();
        }
      });

      observer.observe(productGrid, { childList: true, subtree: true });

      // Fallback: if grid doesn't mutate within 3s, try anyway
      setTimeout(() => {
        observer.disconnect();
        initBundlePrices();
      }, 3000);

    } else {
      // No grid found — just delay and retry
      setTimeout(initBundlePrices, 800);
    }
  });

  // ─── Initial run ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlePrices);
  } else {
    initBundlePrices();
  }
})();
//pricing end




/* ============================================
   Newsletter Popup JS — Home AV Direct
   File: assets/newsletter-popup.js
   ============================================ */

(function () {
  const COOKIE_NAME = 'hav_newsletter_shown';
  const overlay     = document.getElementById('newsletterPopupOverlay');

  if (!overlay) return;

  const closeBtn    = document.getElementById('closeNewsletterPopup');
  const delayMs     = parseInt(overlay.dataset.delay || '0', 10) * 1000;
  const showOnce    = overlay.dataset.showOnce === 'true';

  /* ── Cookie helpers ── */
  function getCookie(name) {
    return document.cookie.split('; ').some(c => c.startsWith(name + '='));
  }
  function setCookie(name, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  /* ── Open / close ── */
  function openPopup() {
    overlay.style.display = 'flex';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add('active'));
    });
    document.body.style.overflow = 'hidden';
    if (showOnce) setCookie(COOKIE_NAME, 30);
  }

  function closePopup() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.style.display = 'none'; }, 380);
  }

  /* ── Trigger: header Subscribe button ── */
  document.querySelectorAll('[data-newsletter-trigger], .newsletter-trigger').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      openPopup();
    });
  });

  /* ── Trigger: auto-show after delay ── */
  if (delayMs > 0) {
    if (!showOnce || !getCookie(COOKIE_NAME)) {
      setTimeout(openPopup, delayMs);
    }
  }

  /* ── Close handlers ── */
  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', e => {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('active')) closePopup();
  });

  /* ── Auto-close after successful Shopify form submission ── */
  const successMsg = overlay.querySelector('.success-message');
  if (successMsg) {
    setTimeout(closePopup, 3000);
  }

})();

// popup end



/**
 * Shopify Facet Filters
 * - Closes all filter panels except the first one on load
 * - Runs after DOM + any app JS is ready
 */

(function () {

  function initFacetFilters() {

    // ❌ Stop if body has search page class
    if (document.body.classList.contains('page-name-search')) {
      return;
    }
    
    // Get all <details> elements inside the filters wrapper
    const allDetails = document.querySelectorAll(
      '.facets__filters-wrapper .facets__panel'
    );

    allDetails.forEach(function (details, index) {
      if (index === 0) {
        // ✅ Keep first filter open
        details.setAttribute('open', '');
      } else {
        // ✅ Remove open from all others
        details.removeAttribute('open');
      }
    });

    // Also update the parent accordion-custom open attribute to match
    const allAccordions = document.querySelectorAll(
      '.facets__filters-wrapper accordion-custom'
    );

    allAccordions.forEach(function (accordion, index) {
      if (index === 0) {
        accordion.setAttribute('open', '');
      } else {
        accordion.removeAttribute('open');
      }
    });
  }

  // ✅ Run after full page + scripts are loaded
  if (document.readyState === 'complete') {
    initFacetFilters();
  } else {
    window.addEventListener('load', initFacetFilters);
  }

})();


function toggleWishlist(event, button) {

  event.stopPropagation(); // prevents other JS click events
  event.preventDefault();  // prevents link navigation if inside <a>

  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  const product = {
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    image: button.dataset.productImage,
    url: button.dataset.productUrl
  };

  const index = wishlist.findIndex(item => item.handle === product.handle);

  if (index > -1) {
    wishlist.splice(index, 1);
    button.classList.remove("active");
  } else {
    wishlist.push(product);
    button.classList.add("active");
  }

  localStorage.setItem("wishlist", JSON.stringify(wishlist));
}

// function toggleWishlist(button) {
  //   let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  //   const product = {
  //     handle: button.dataset.productHandle,
  //     title: button.dataset.productTitle,
  //     image: button.dataset.productImage,
  //     url: button.dataset.productUrl
  //   };

  //   const index = wishlist.findIndex(item => item.handle === product.handle);

  //   if (index > -1) {
  //     wishlist.splice(index, 1);
  //     button.classList.remove("active");
  //   } else {
  //     wishlist.push(product);
  //     button.classList.add("active");
  //   }

  //   localStorage.setItem("wishlist", JSON.stringify(wishlist));
  // }
    // Optional: mark buttons active on page load
  document.addEventListener("DOMContentLoaded", function () {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    document.querySelectorAll(".wishlist-btn").forEach(button => {
      if (wishlist.find(item => item.handle === button.dataset.productHandle)) {
        button.classList.add("active");
      }
    });
  });

/////////////////////////

const menuToggle = document.getElementById("menuToggle");
const navLinks = document.getElementById("navLinks");
const dropdownLists = document.querySelectorAll(".dropdown_list");

/* Toggle main menu */
menuToggle.addEventListener("click", () => {
  menuToggle.classList.toggle("active");
  navLinks.classList.toggle("active");
});

/* Dropdown toggle */
dropdownLists.forEach(dropdown => {
  const toggle = dropdown.querySelector(".dropdown_toggle");

  toggle.addEventListener("click", (e) => {
    if (window.innerWidth < 1024) {
      e.preventDefault();
      e.stopPropagation();

      // Close others
      dropdownLists.forEach(item => {
        if (item !== dropdown) {
          item.classList.remove("active");
        }
      });

      dropdown.classList.toggle("active");
    }
  });
});

// $('.banner_slider').owlCarousel({
//   items:1,
//   loop:true,
//   autoplay:true,
//   autoplayTimeout:5000,
//   smartSpeed:1000,
//   animateOut:'fadeOut',
//   animateIn:'fadeIn',
//   mouseDrag:true,
//   touchDrag:true,
//   pullDrag:false,
//   nav:false,
//   dots:false
// });

$('.owl-carousel-1').owlCarousel({
    loop:true,
    items:1,
    margin:10,
    autoplay:false,
    nav:false,
    dots:false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    smartSpeed:1000,
    autoplayTimeout:5000,
    mouseDrag:true,
    touchDrag:true,
    pullDrag:false
})

$('.excellent_slider').owlCarousel({
  loop: true,
  margin: 30,
  stagePadding: 5,
  nav: false,
  dots: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    992: {
      items: 3
    }
  }
})


$(document).ready(function () {
  setInterval(function () {
  var bigimage = $("#big");
  var thumbs = $("#thumbs");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage
    .owlCarousel({
      items: 1,
      slideSpeed: 2000,
      nav: true,
      autoplay: true,
      dots: false,
      loop: true,
      responsiveRefreshRate: 200,
      navText: [
        '<i class="fa-solid fa-chevron-left"></i>',
        '<i class="fa-solid fa-chevron-right"></i>'
      ]
    })
    .on("changed.owl.carousel", syncPosition);

  thumbs
    .on("initialized.owl.carousel", function () {
      thumbs
        .find(".owl-item")
        .eq(0)
        .addClass("current");
    })
    .owlCarousel({
      items: 5,
      margin: 15,
      autoplay: true,
      stagePadding: 40,
      dots: false,
      nav: true,
      navText: [
        '<i class="fa-solid fa-chevron-left"></i>',
        '<i class="fa-solid fa-chevron-right"></i>'
      ],
      responsive: {
        0: {
          items: 2
        },
        350: {
          items: 3
        },
        430: {
          items: 4
        },
        575: {
          items: 5
        },
      },
      smartSpeed: 200,
      slideSpeed: 500,
      slideBy: 1,
      responsiveRefreshRate: 100
    })
    .on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs
      .find(".owl-item.active")
      .first()
      .index();
    var end = thumbs
      .find(".owl-item.active")
      .last()
      .index();

    if (current > end) {
      thumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function (e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });
  }, 1000);
});

// increase and decrease the quantity. 
// const minus = document.querySelector(".minus");
// const plus = document.querySelector(".plus");
// const input = document.querySelector(".qty input");

// minus.onclick = () => {
//   if (input.value > 1) {
//     input.value--;
//   }
// }

// plus.onclick = () => {
//   input.value++;
// }


$(document).ready(function () {
  $('.related__products_slider').owlCarousel({
    margin: 19,
    items: 3,
    slideSpeed: 2000,
    nav: true,
    autoplay: true,
    dots: false,
    loop: true,
    responsiveRefreshRate: 200,
    navText: [
      '<i class="fa-solid fa-chevron-left"></i>',
      '<i class="fa-solid fa-chevron-right"></i>'
    ],
    responsive: {
        0: {
          items: 1
        },
        680: {
          items: 2
        },
        991: {
          items: 3
        },
      },
  });
}); 



  function toggleShippingCalc() {
    var body = document.getElementById('calc-body');
    var icon = document.getElementById('calc-toggle-icon');
    var isOpen = body.style.display !== 'none';
    body.style.display = isOpen ? 'none' : 'block';
    icon.textContent = isOpen ? '﹢' : '﹣';
  }
  // ── Global: Calculate Shipping ──
  function calculateShipping() {
    var countrySelect  = document.getElementById('calc-country');
    var provinceSelect = document.getElementById('calc-province');
    var zipInput       = document.getElementById('calc-zip');
    var submitBtn      = document.getElementById('calc-submit');
    var responseDiv    = document.getElementById('calc-response');

    var country  = countrySelect.value;
    var province = provinceSelect.value;
    var zip      = zipInput.value.trim();

    if (!country || !zip) {
      responseDiv.innerHTML = '<p style="color:red;">Please enter your country and ZIP code.</p>';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Calculating...';
    responseDiv.innerHTML = '';

    var url = '/cart/shipping_rates.json'
      + '?shipping_address[zip]='      + encodeURIComponent(zip)
      + '&shipping_address[country]='  + encodeURIComponent(country)
      + '&shipping_address[province]=' + encodeURIComponent(province);

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Calculate Shipping';

        if (data.shipping_rates && data.shipping_rates.length > 0) {
          var html = '<p style="font-weight:bold; margin-bottom:8px;">Available shipping rates:</p><ul style="list-style:none; padding:0; margin:0;">';
          data.shipping_rates.forEach(function (rate) {
            var price = parseFloat(rate.price) === 0
              ? '<strong>FREE</strong>'
              : '<strong>' + rate.currency + ' ' + parseFloat(rate.price).toFixed(2) + '</strong>';
            html += '<li style="padding:8px 0; border-bottom:1px solid #eee;">'
              + rate.name + ' — ' + price + '</li>';
          });
          html += '</ul>';
          responseDiv.innerHTML = html;
        } else if (data.error) {
          responseDiv.innerHTML = '<p style="color:red;">' + data.error + '</p>';
        } else {
          responseDiv.innerHTML = '<p>No shipping rates found for this address.</p>';
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Calculate Shipping';
        responseDiv.innerHTML = '<p style="color:red;">Something went wrong. Please try again.</p>';
      });
  }

document.addEventListener('DOMContentLoaded', function () {
  var countrySelect   = document.getElementById('calc-country');
  var provinceSelect  = document.getElementById('calc-province');
  var provinceWrapper = document.getElementById('calc-province-wrapper');
  var provinceData    = document.getElementById('calc-country-province-data');

  function updateProvinces() {
    var selectedCountryOption = provinceData
      ? provinceData.querySelector('option[value="' + countrySelect.value + '"]')
      : null;

    provinceSelect.innerHTML = '<option value="">Select province</option>';

    if (selectedCountryOption) {
      var subregions = selectedCountryOption.dataset.provinces;
      if (subregions) {
        try {
          var parsed = JSON.parse(subregions);
          if (parsed && parsed.length > 0) {
            parsed.forEach(function (p) {
              var opt = document.createElement('option');
              opt.value = p[0];
              opt.textContent = p[1];
              provinceSelect.appendChild(opt);
            });
            provinceWrapper.style.display = 'block';
            return;
          }
        } catch (e) {}
      }
    }
    provinceWrapper.style.display = 'none';
  }

  updateProvinces();
  countrySelect.addEventListener('change', updateProvinces);

  // ── Sync country from header dropdown ──
  var headerCountrySelect = document.querySelector('#HeaderCountryForm select[name="country_code"]');

  function syncCountryFromHeader() {
    if (!headerCountrySelect || !countrySelect) return;

    var selectedOption = headerCountrySelect.selectedOptions[0];
    var selectedName   = selectedOption.dataset.countryName;

    var options = countrySelect.options;
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === selectedName) {
        countrySelect.selectedIndex = i;
        break;
      }
    }

    updateProvinces();
  }

  syncCountryFromHeader();
});


// contact form number validation
